/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import "./profile.css";
import { useEffect, useState } from "react";

import swal from "sweetalert";
import UpdateProfileModal from "./UpdateProfileModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import person from "../../images/doctors/person.png"
import {
  deleteProfile,
  getUserProfile,
  // uploadProfilePhoto,
} from "../../redux/apiCalls/profileApiCalls";
import DoctorItem from "../../components/docotors-components/DoctorItem";
import { RotatingSquare } from "react-loader-spinner";
import { logoutUser } from "../../redux/apiCalls/authApiCall";

const Profile = () => {
  const navigate = useNavigate();

  const { loading, isProfileDeleted } = useSelector((state) => state.profile);
  const { profile } = useSelector((state) => state.profile);
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  // const [file, setFile] = useState(null);
  const [updateProfile, setUpdateProfile] = useState(false);

  // const updateProfileImagesubmitHandler = (e) => {
  //   e.preventDefault();
  //   if (!file) {
  //     return toast.warning("لم يتم اختيار صورة");
  //   }
  //   const formData = new FormData();
  //   formData.append("image", file);
  //   dispatch(uploadProfilePhoto(formData));
  //   console.log(formData);
  // };

  //Delete account handler
  const deleteAccountHandler = () => {
    swal({
      title: "هل تريد فعلا الحذف ؟",
      text: "سوف يتم حذف البروفايل وكل البيانات المتعلقة به",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteProfile(user?._id));
        dispatch(logoutUser());
      }
    });
  };

  const { id } = useParams();

  useEffect(() => {
    dispatch(getUserProfile(id));
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    if (profile === null || isProfileDeleted) {
      navigate("/");
    }
  }, [navigate, isProfileDeleted]);

  if (loading) {
    return (
      <div className="profile-loader">
        <RotatingSquare
          height="100"
          width="100"
          color="#4fa94d"
          ariaLabel="rotating-square-loading"
          strokeWidth="4"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <div className="profile">
      <div className="profile-img-wrapper">
        <img
          src={person}
          alt="image"
        />
        {/* {user?._id === profile?._id && (
          <form
            onSubmit={updateProfileImagesubmitHandler}
            className="update-doctor-image"
          >
            <label htmlFor="file" className="update-profile-label">
              <BsFillCameraFill className="update-profile-label ms-2" />
            </label>
            <input
              onChange={(e) => setFile(e.target.files[0])}
              type="file"
              name="file"
              id="file"
            />
            <button type="submit" className="image-button">
              تحميل صورة
            </button>
          </form>
        )} */}

        <div className="prfile-user-name">
          <strong>{profile?.username?.substr(0, 25)} </strong>
          <p className="profile-bio">{profile?.bio?.substr(0, 80)}</p>
          <div className="user-date-goined">
            <span>التسجيل بالموقع</span>
            <span> {new Date(profile?.createdAt).toDateString()}</span>
          </div>
        </div>
        {user?._id === profile?._id && (
          <button
            onClick={() => setUpdateProfile(true)}
            className="profile-update-btn"
          >
            تحديث البروفايل
          </button>
        )}
      </div>
      <div className="profile-doctors-list">
        <h6>البيانات التى شاركها : {profile?.username?.substr(0, 25)} </h6>
      </div>
      <div className="profile-doctors-list-wrapper">
        <div className="profile-doctors-list-wrapper-list">
          {profile?.doctors?.map((doctor) => (
            <DoctorItem
              key={doctor?._id}
              doctor={doctor}
              username={profile?.username?.substr(0, 25)}
              userId={profile?._id}
            />
          ))}
        </div>
        {user?._id === profile?._id && (
          <button
            onClick={() => deleteAccountHandler()}
            className="delete-account-btn"
          >
            حذف البروفايل
          </button>
        )}

        {updateProfile && (
          <UpdateProfileModal
            profile={profile}
            setUpdateProfile={setUpdateProfile}
          />
        )}
      </div>
    </div>
  );
};

export default Profile;
